// extracted by mini-css-extract-plugin
export default {"root":"R01VUkXOaEwo1HjlE7X3","wrap":"XA9fgmk2oO1wvvrP1vvp"};